require('../../modules/es6.array.find');
module.exports = require('../../modules/_core').Array.find;



//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/fn/array/find.js
// module id = 306
// module chunks = 1